<template>
    <div>
      <div>
        <el-table
          ref="filterTable"
          stripe
          border
          @current-change="handleCurrentChange"
          :data="tableData">
          <el-table-column prop="termid" label="终端id" sortable column-key="termid"></el-table-column>
          <el-table-column prop="deveui" label="终端串号" sortable column-key="deveui"></el-table-column>
          <el-table-column prop="usrname" label="终端拥有者" sortable column-key="usrname" :filters="userTer" :filter-method="filterHandler"></el-table-column>
          <el-table-column prop="status" label="终端状态" sortable column-key="status"></el-table-column>
          <el-table-column prop="intime" label="上线时间" sortable column-key="intime"></el-table-column>
          <el-table-column prop="outtime" label="下线时间" sortable column-key="outtime"></el-table-column>
        </el-table>
      </div>
      <el-dialog :visible.sync="display_equip" :before-close="handleClose">
        <div>
          <el-table
            :data="phyList"
            >
            <el-table-column  prop="phyname" label="传感器名称" sortable column-key="phyname"></el-table-column>
            <el-table-column prop="phystatus" label="状态" sortable column-key="phystatus"></el-table-column>
            <el-table-column  prop="lstime" label="最后上报时间" sortable column-key="lstime"></el-table-column>
          </el-table>
        </div>
      </el-dialog>
    </div>
</template>

<script>
export default {
  data () {
    return {
      token: window.sessionStorage.getItem('token'),
      username: window.sessionStorage.getItem('username'),
      tableData: [],
      userTer: [],
      listTerm: [],
      display_equip: false,
      listUsers: [],
      tableData2: [],
      phyList: []
    }
  },
  methods: {
    // 获取 所有用户信息
    getAllusers () {
      this.listUsers = []
      this.axios.get(this.$store.state.loginIp + 'admin/lists',
        {
          params: {'pageSize': 100, 'role': '2'},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.listUsers = res.data.data.list
        let i
        for (i = 0; i < this.listUsers.length; i++) {
          this.getUserTerm(this.listUsers[i].username)
          this.getAllSta(this.listUsers[i].username)
        }
        if (i === this.listUsers.length) {
          this.getAllTermSta()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取 用户的所有终端
    getUserTerm (username) {
      this.axios.get(this.$store.state.ip + 'termdef/listTermsByUsr',
        {
          params: {'user_name': username},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        if (res.data.data.list.length > 0) {
          for (let i = 0; i < res.data.data.list.length; i++) {
            this.listTerm.push({'id': res.data.data.list[i].id, 'deveui': res.data.data.list[i].deveui})
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取所有设备的在线状态
    getAllTermSta () {
      this.axios.get(this.$store.state.ip + 'opt/allTermSta',
        {
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        this.tableData = res.data.data
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].intime === null) {
            this.tableData[i].intime = 'null'
          }
          if (this.tableData[i].outtime === null) {
            this.tableData[i].outtime = 'null'
          }
          if (this.tableData[i].status === true) {
            this.tableData[i].status = '开'
          } else {
            this.tableData[i].status = '关'
          }
          let j
          for (j = i + 1; j < this.tableData.length; j++) {
            if (this.tableData[i].usrname === this.tableData[j].usrname) {
              break
            }
          }
          if (j === this.tableData.length) {
            this.userTer.push({text: this.tableData[i].usrname, value: this.tableData[i].usrname})
          }
          for (let k = 0; k < this.listTerm.length; k++) {
            if (this.listTerm[k].id === this.tableData[i].termid) {
              this.tableData[i].deveui = this.listTerm[k].deveui
            }
          }
          if (!this.tableData[i].deveui) {
            this.tableData[i].deveui = 'null'
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    filterHandler (value, row, column) {
      const property = column['property']
      return row[property] === value
    },
    handleCurrentChange (val) {
      this.display_equip = true
      this.getAllList(val.termid)
    },
    // 查询用户下所有终端的状态
    getAllSta (username) {
      this.axios.get(this.$store.state.ip + 'opt/usrTermSta',
        {
          params: {'usrname': username},
          headers: {'Authorization': 'Bearer ' + this.token}
        }).then(res => {
        let test = res.data.data
        for (let i = 0; i < test.length; i++) {
          this.tableData2.push({'termid': test[i].termid, 'termname': test[i].termname, 'phyList': test[i].phyList})
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取终端下所有传感器的状态
    getAllList (termid) {
      for (let i = 0; i < this.tableData2.length; i++) {
        if (this.tableData2[i].termid === termid) {
          this.phyList = this.tableData2[i].phyList
        }
      }
      for (let j = 0; j < this.phyList.length; j++) {
        if (this.phyList[j].phystatus === 'false') {
          this.phyList[j].phystatus = '关'
        } else {
          this.phyList[j].phystatus = '开'
        }
      }
    },
    // 弹窗
    handleClose (done) {
      done()
    }
  },
  created () {
    this.getAllusers()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/onlineDevice.vue